import Golfer from './Golfer';
import Course from './Course';
import Alpine from 'alpinejs';
window.Alpine = Alpine;

const cedarCreek = new Course();
const startingGolfers = [new Golfer('Beans'),new Golfer('Bones'), new Golfer('Bananas'), new Golfer('Spirit Pete'),new Golfer('Mean Joe Purple')]

Alpine.store('state', {
    screen: 'selection',
    golfers: startingGolfers,
    course: null,
    activeHole: cedarCreek.holes[0],
    activeGolfer: null,

// METHODS
    init(){
      this.golfers = startingGolfers;
      this.course = cedarCreek;
      this.activeHole = cedarCreek.holes[0];
      this.activeGolfer = this.golfers[0]
    },
    get holeScore(){
      return this.activeGolfer.scores[this.activeHole.number -1 ]
    },
    selectGolfer(golfer){
      this.activeGolfer = golfer;
      this.screen = 'scorecard'
      this.activeHole = cedarCreek.holes[this.activeGolfer.currentHoleNumber]
    },
    addGolfer(inputName){
      this.golfers.push(new Golfer(inputName))
    },
    updateScore(amt){
      this.activeGolfer.scores[this.activeHole.number -1] += amt
    },
    nextHole(){
      this.activeHole = this.course.holes[this.activeHole.number]
    },
    previousHole(){
      this.activeHole = this.course.holes[this.activeHole.number - 2]
    }, 
    get golfersSorted(){
      return this.golfers.sort((a,b) => {
        // if no holes played, move to bottom
        if (a.numHolesPlayed == 0){return 1}

        let scoreDif = a.getRelativeTotalScore(this.course.parArray) - b.getRelativeTotalScore(this.course.parArray);
        // if score is same, whoever has played more is on top
        if (scoreDif == 0){return b.numHolesPlayed - a.numHolesPlayed}

        // otherwise order by score, lowest to highest
        return scoreDif
      })
    }
})

Alpine.start()